module.exports = "query ($id: String!) {\n    friendRequest(friendingUserId: $id)\n}\n"